import { lazy } from "react";
import SuspenseWrapper from "components/SuspenseWrapper";

const TrendingSupplementDetails = lazy(
  () => import("modules/trending-supplement-details/TrendingSupplementDetails")
);
export default function TrendingSupplementDetailsPage() {
  return (
    <SuspenseWrapper>
      <TrendingSupplementDetails />
    </SuspenseWrapper>
  );
}
